import {
  ArrowRight,
  BrainCircuit,
  CheckCircle2,
  ClipboardList,
  FileCheck2,
  Gauge,
  Link2,
  ShieldCheck,
  Users,
  Workflow,
} from 'lucide-react'
import { Link } from 'react-router-dom'
import { PageHero, SectionHeader } from './shared'

export function PlatformPage() {
  return (
    <>
      <PageHero
        title="What DAWN does, in plain English"
        copy="DAWN helps a business organise what it knows, prepare repeat work, keep track of what is happening and bring important decisions back to a person. You do not need to understand AI to use it."
      />

      <section className="section">
        <div className="container platform-feature-grid">
          {[
            ['Keeps business information together', 'DAWN uses the information you approve—such as services, products, processes and brand rules—so work does not begin from scratch each time.', BrainCircuit],
            ['Turns repeat jobs into clear steps', 'Jobs such as preparing a newsletter, checking a catalogue or researching a lead can follow the same reliable process every time.', ClipboardList],
            ['Prepares work for review', 'It can gather information and produce a first draft, checklist, summary or recommendation before a person takes over.', Workflow],
            ['Brings decisions back to you', 'Important messages, publishing, spending and changes can be held in one approval list rather than happening in the background.', FileCheck2],
            ['Works with tools you already use', 'DAWN is designed to connect with systems such as email, Drive, your website, CRM and shop instead of forcing you to replace everything.', Link2],
            ['Shows what happened', 'You can see which jobs ran, what was prepared, what needs attention and where time or money is being used.', Gauge],
          ].map(([title, copy, Icon]) => (
            <article key={title as string}>
              <Icon size={24} />
              <h3>{title as string}</h3>
              <p>{copy as string}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="section architecture-section">
        <div className="container">
          <SectionHeader
            align="center"
            title="A simple journey from information to finished work"
            copy="The complicated technology stays behind the scenes. The experience for the customer should remain straightforward."
          />
          <div className="architecture-map architecture-map--plain">
            <div className="architecture-node architecture-node--client"><Users /><strong>Your business</strong><small>You choose the problem, information and rules</small></div><ArrowRight />
            <div className="architecture-node"><BrainCircuit /><strong>DAWN prepares</strong><small>It gathers, checks, organises and drafts the work</small></div><ArrowRight />
            <div className="architecture-node"><ShieldCheck /><strong>You review</strong><small>Important decisions remain with you or your team</small></div><ArrowRight />
            <div className="architecture-node architecture-node--data"><CheckCircle2 /><strong>The job moves forward</strong><small>Approved work is completed or passed to the right tool</small></div>
          </div>
          <div className="deployment-levels">
            <article><ClipboardList /><h3>Start with one job</h3><p>Choose one repeat task that is wasting time or being missed.</p></article>
            <article><Workflow /><h3>Add more when it works</h3><p>Expand into other areas only after the first workflow proves useful.</p></article>
            <article><ShieldCheck /><h3>Use stronger privacy when needed</h3><p>Larger or sensitive businesses can use tighter access and separate environments.</p></article>
          </div>
          <div className="plain-page-cta"><Link className="button button--gold" to="/request-demo">Show us the job you want help with <ArrowRight size={17} /></Link></div>
        </div>
      </section>
    </>
  )
}
